import React from 'react';
import { Star, Quote } from 'lucide-react';
import { motion } from 'framer-motion';

const testimonials = [
  {
    id: 1,
    name: 'Monika Schmittz',
    role: 'Tech-Enthusiast',
    content: 'Ich habe mein neues Smartphone hier gekauft und bin begeistert von der schnellen Lieferung und dem ausgezeichneten Kundenservice. Die Beratung war kompetent und hilfreich.',
    rating: 5,
    image: 'https://images.pexels.com/photos/732425/pexels-photo-732425.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
  },
  {
    id: 2,
    name: 'Tomas Meler',
    role: 'Geschäftsmann',
    content: 'Die Kombination aus Smartphone und passendem Tarif war genau das, was ich suchte. Die Website ist übersichtlich und die Informationen sind klar strukturiert.',
    rating: 5,
    image: 'https://images.pexels.com/photos/2379005/pexels-photo-2379005.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
  },
  {
    id: 3,
    name: 'Suzi Helman',
    role: 'Studentin',
    content: 'Als Studentin war ich auf der Suche nach einem guten Preis-Leistungs-Verhältnis. Hier habe ich ein tolles Angebot gefunden und konnte viel Geld sparen!',
    rating: 4,
    image: 'https://images.pexels.com/photos/1090387/pexels-photo-1090387.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
  }
];

const Testimonials: React.FC = () => {
  return (
    <section className="py-16 bg-gray-50 overflow-hidden">
      <div className="container mx-auto px-4">
        <motion.div
          className="text-center mb-12"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl font-bold text-gray-800">Was unsere Kunden sagen</h2>
          <p className="mt-2 text-gray-600 max-w-2xl mx-auto">
            Erfahren Sie, warum unsere Kunden uns vertrauen und immer wieder zu uns zurückkommen
          </p>
        </motion.div>

        <div className="grid gap-8 md:grid-cols-3">
          {testimonials.map((testimonial, i) => (
            <motion.div
              key={testimonial.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.55, delay: i * 0.15 }}
              whileHover={{ y: -5, boxShadow: '0 16px 32px rgba(0,0,0,0.1)' }}
              className="bg-white p-6 rounded-xl shadow-md relative"
            >
              <motion.div
                className="absolute top-4 right-4 text-blue-100"
                initial={{ opacity: 0, scale: 0.5 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.15 + 0.3, duration: 0.4 }}
              >
                <Quote className="w-8 h-8" />
              </motion.div>

              <div className="flex items-center gap-4 mb-4">
                <motion.img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover ring-2 ring-blue-100"
                  initial={{ scale: 0.8, opacity: 0 }}
                  whileInView={{ scale: 1, opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.15 + 0.2, duration: 0.4 }}
                />
                <div>
                  <h4 className="font-bold text-lg">{testimonial.name}</h4>
                  <p className="text-gray-500 text-sm">{testimonial.role}</p>
                </div>
              </div>

              <div className="flex mb-3 gap-0.5">
                {[...Array(5)].map((_, j) => (
                  <motion.span
                    key={j}
                    initial={{ opacity: 0, scale: 0 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.15 + 0.3 + j * 0.06, duration: 0.25 }}
                  >
                    <Star
                      className={`w-4 h-4 ${
                        j < testimonial.rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'
                      }`}
                    />
                  </motion.span>
                ))}
              </div>

              <p className="text-gray-700 text-sm leading-relaxed">{testimonial.content}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
